import {
  MuiBox,
  MuiTypography
} from "../../../components";
import { BillingConfigurationHeaderWrapper } from "./BillingConfigurationHeader.style";

export const BillingConfigurationHeader: React.FC<{
  header: string;
}> = ({ header }) => {
  return (
    <BillingConfigurationHeaderWrapper>
      <MuiBox className="dashed-line" />
      <MuiTypography variant="h3Bold">{header}</MuiTypography>
    </BillingConfigurationHeaderWrapper>
  );
};
